import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { ProcedureType, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { ProcedureTypeIcon } from "../Icons/ProcedureTypeIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface ProcedureTypeMultiSelectGroupProps extends MenuMultiSelectGroupProps<Stored<ProcedureType>> {
	procedureTypes: Stored<ProcedureType>[]
}

export const ProcedureTypeMultiSelectGroup = memo<ProcedureTypeMultiSelectGroupProps>((props) => {
	const { ref, procedureTypes, ...rest } = props

	return (
		<Menu.MultiSelectGroup<Stored<ProcedureType>> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{procedureTypes.map((procedureType) => {
				return (
					<MultiSelectItemTemplate<Stored<ProcedureType>> key={procedureType.uuid} value={procedureType}>
						<ProcedureTypeIcon procedureTypeId={procedureType.uuid} />
						<Text className="truncate">{procedureType.name}</Text>
					</MultiSelectItemTemplate>
				)
			})}
		</Menu.MultiSelectGroup>
	)
})
ProcedureTypeMultiSelectGroup.displayName = "ProcedureTypeMultiSelectGroup"
